import { type SessionSubType } from '../components/infcon-2023/commons/constants';

export type SessionSubTypeResponse = 'SESSION' | 'PARTICIPATION';

export type PageResponse = {
  id: number;
  title: string;
  slug: string;
  type: string;
  body: string;
  subType: SessionSubTypeResponse;
  data: PageData & SessionPageData;
  createdAt: Date;
  storage: 's3';
  url: string;
  hasSchedule: boolean;
};

export type PageData = {
  width: string;
  tag_id: number | null;
  has_post: boolean;
  backgroundColor: string;
  title: string;
  id: number;
  type: string;
  subType: SessionSubType;
};

export type SessionPageData = {
  trackName?: string;
  affiliation?: string;
  speakerName?: string;
  sessionLocation?: string;
  sessionSchedule?: string;
};

class PageDto {
  readonly id: number;
  readonly title: string;
  readonly slug: string;
  readonly type: string;
  readonly body: string;
  readonly subType: string;
  readonly thumbnailUrl: string;

  constructor(response: PageResponse) {
    this.id = response.id;
    this.title = response.title;
    this.slug = response.slug;
    this.type = response.type;
    this.body = response.body;
    this.subType = response.subType;
    this.thumbnailUrl = response.url;
  }
}

export default PageDto;
